import { postRequest } from '@bo-apis/axios';

const getMemberCount = ({ searchForm }) =>
  postRequest({
    url: 'api/v1/co/member/get-member-count',
    data: { ...searchForm },
  });

const getSbComList = ({ searchForm }) =>
  postRequest({
    url: 'api/v1/co/member/get-sbcom-list',
    data: { ...searchForm },
  });

const getMemberList = ({ form, pageable }) =>
  postRequest({
    url: 'api/v1/co/member/get-member-list',
    params: { ...pageable },
    data: { ...form },
  });

const getCoSiteMemberList = ({ form, pageable }) =>
  postRequest({
    url: 'api/v1/co/site/member/get-member-list',
    params: { ...pageable },
    data: { ...form },
  });

const createCoSiteMemberList = (payload) =>
  postRequest({
    url: 'api/v1/co/site/member/save-member-list',
    data: payload,
  });

export default {
  getMemberCount,
  getSbComList,
  getMemberList,
  getCoSiteMemberList,
  createCoSiteMemberList,
};
